import type { CallCenterV3Types } from "@EspaceParkQC/sdk-services-legacy";

export default function AgentParty({
  agentPartyDetails,
}: {
  agentPartyDetails: CallCenterV3Types.CallPartyAgent | undefined;
}): React.ReactElement | null {
  if (!agentPartyDetails) return null;

  const name = `${agentPartyDetails.firstName} ${agentPartyDetails.lastName}`;

  return (
    <div className="w-full h-full flex justify-center items-center">
      <h1 className="text-lg font-bold text-center">{name}</h1>
    </div>
  );
}
